export default {
  'user': '@:terms.user',
  'info': {
    'user': '내 개인정보',
    'company': '내 회사정보',
  },
  'my-info': '@:terms.my @:terms.info',
  'phone': '@:terms.phone-number',
  'name': '@:terms.name',
  'email': '@:terms.email',
  'boss': '@:terms.boss',
  'address': '@:terms.address',
  'biz-name': '@:terms.biz-name',
  'biz-class': '@:terms.biz-class',
  'biz-type': '@:terms.biz-type',
  'biz-owner-phone-number': '회사 대표 @:terms.phone-number',
  'biz-registration-number': '@:terms.business-operator@:terms.registration-number',
  'registration-number': '@:terms.business-operator@:terms.registration-number',
  'corporate-registration-number': '@:terms.corporate@:terms.registration-number',
  'input': '@:terms.input',
  'edit': '@:terms.edit',
  'complete': '@:terms.complete',
  'edit-action': '@:terms.edit@:terms.complete',
  'search': '@:terms.search',
  'sign-out': '로그아웃',
  'verification': {
    'required': {
      'biz-name': '@:terms.biz-name을 입력해주세요.',
      'biz-registration-number': '@:pages.sign-up.biz.biz-registration-number를 입력해주세요.',
      'corporate-registration-number': '@:pages.sign-up.biz.corporate-registration-number를 ' +
        '입력해주세요.',
      'owner-name': '@:pages.sign-up.biz.owner-name을 입력해주세요.',
      'registration-number': '@:pages.sign-up.biz.registration-number를 입력해주세요.',
      'biz-phone-number': '@:pages.sign-up.biz.biz-phone-number를 입력해주세요.',
      'owner-email': '@:pages.sign-up.biz.owner-email을 입력해주세요.',
    },
    'format': {
      'biz-registration-number': '@:pages.sign-up.biz.biz-registration-number형식에 맞게 입력해주세요. ',
      'corporate-registration-number': '@:pages.sign-up.biz.corporate-registration-number형식에 ' +
        '맞게 입력해주세요.',
      'biz-phone-number': '@:pages.sign-up.biz.biz-phone-number형식에 맞게 입력해주세요.',
      'registration-number': '@:pages.sign-up.biz.registration-number형식에 맞게 입력해주세요.',
      'owner-email': '@:terms.email형식에 맞게 입력해주세요.',
    },
  },
  'error': {
    'get-biz': '회사 정보를 불러오는데 실패하였습니다.',
    'update-biz': '회사 정보를 수정하는데 실패하였습니다.',
  },
}
